function getFileNameOnly(filePath) {
  return filePath.split('/').pop().split('.').shift();
}

export function loadFolderJSONs(requiredContext) {
  const json = {};
  requiredContext.keys().forEach((key) => {
    const obj = requiredContext(key);
    const simpleKey = getFileNameOnly(key);
    obj.fileName = simpleKey;
    json[simpleKey] = obj;
  });
  return json;
}